export default __webpack_public_path__ + "static/media/Sebastian.4d3b86c0.png";